import { createFileRoute } from "@tanstack/react-router";
import { OverviewPage } from "@/components/dashboard/overview-page";

export const Route = createFileRoute("/")({
  head:()=>({meta:[{title:"Overview — Deuxda Admin"},{name:"description",content:"Deuxda marketplace growth, revenue and operational priorities."},{property:"og:title",content:"Overview — Deuxda Admin"},{property:"og:description",content:"Deuxda marketplace growth, revenue and operational priorities."},{property:"og:type",content:"website"},{name:"twitter:card",content:"summary_large_image"}]}),
  component:OverviewPage,
});
